module.exports = __webpack_public_path__ + "static/img/sports-legacy.d255faf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tmf/sports-legacy.svg
// module id = 6oLT
// module chunks = 1